import React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import async from 'async';
import { Form } from 'react-form';
import { Card, CardText } from 'material-ui';
import _ from 'lodash';
import Translate from 'translate';
import ReactTable from 'react-table';
// import AsyncTable from 'components/HTMLElements/Table/AsyncTable/';
import NetworkService from 'services/NetworkService'
import { FormGroup, Text, Textarea, Select } from 'components/FormElements';
import { toggleAlertError, toggleLoading } from 'stores/actions/';
import { required, validFixedLine } from 'constants/InputErrors';
class SearchComplaintModal extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      data: [],
      logsData: [],
      deleteModalOpened: false,
    };
    this.submitForm = this.submitForm.bind( this );
    this.toogleSubmmitted = this.toogleSubmmitted.bind( this );
    this.getData = this.getData.bind( this );
  }
  componentDidMount() {
   // this.getData()
  }
  componentWillReceiveProps( nextProps ) {
    if ( nextProps.open && !this.props.open ) {
      this.setState( { data: [], submitted: false } )
      // this.getData2();
    }
  }

  toogleSubmmitted() {
    const { submitted } = this.state;
    this.setState({ submitted: !submitted }); 
  }
  getData() {
    this.props.toggleLoading( true );

    async.parallel( {
      data: this.getData2.bind( this ),
    }, ( error, results ) => {
      this.props.toggleLoading( false );
      if( !error || error === 'Type not found.' ) this.setState( results )
    } )
  }

  getData2( cb ) {
    const { isLoading, toggleLoading, type } = this.props;
    // this.params = params;

    if( !isLoading ) toggleLoading( true );

    
    //apiParams[`filters[type]`] = type.toLowerCase();
    //if( params.sorted.length ) apiParams[`sortby[${params.sorted[0].id}]`] = params.sorted[0].desc ? 'DESC' : 'ASC';

    NetworkService.searchEmailGlobalContacts( this.props.user.id ).then( ( response ) => {
      if( cb ) return cb( response.errors, response.data );

      toggleLoading( false );

      if( response.data ) {
        this.setState( {
          data: response.data.data || [],
          pages: Math.ceil( response.data.total / 10 ),
          total: response.data.total,
        } );
      }
    } )
  }
  submitForm( data ) {
    const { channel, onClose, onReloadData, toggleAlertError, toggleLoading } = this.props;

    toggleLoading( true );

    NetworkService.searchEmailGlobalContacts( this.props.user.id, data ).then( ( response ) => {
      // if( cb ) return cb( response.errors, response.data );

      toggleLoading( false );

      if( response.data ) {
        this.setState( {
          data: response.data.data || [],
          pages: Math.ceil( response.data.total / 10 ),
          total: response.data.total,
          submitted: true,
        } );
      } else this.setState({ submitted: true });
    } )
  }
  render() {
    const { onSelectCard, onClose, open, emailField } = this.props;
    const { ...rest } = this.state;
    return (
      <Modal closeOnEsc={false}
             little
             modalClassName="modal-search-incms col-md-8"
             open={open}
             onClose={() => {
               this.setState( { data: [] } );
               onClose()
             }}>
        <h5 className="mt-0"><Translate id="globalAddressList"/></h5>
        {!this.state.submitted &&
        <Form onSubmit={this.submitForm}>
          {( { getValue, submitForm } ) =>
            <form onSubmit={submitForm}>
              <div className="row">
                <FormGroup containerClass="col-md-6">
                  <label><Translate id="name"/></label>
                  <Text field="name" className="form-control"/>
                </FormGroup>
                <FormGroup containerClass="col-md-6">
                  <label><Translate id="title"/></label>
                  <Text field="title" className="form-control"/>
                </FormGroup>
              </div>
              <div className="row">
                <FormGroup containerClass="col-md-6">
                  <label><Translate id="phone"/></label>
                  <Text field="phone" className="form-control"/>
                </FormGroup>
                <FormGroup containerClass="col-md-6">
                  <label><Translate id="contactAddress"/></label>
                  <Text field="email" className="form-control"/>
                </FormGroup>
              </div>
              <div className="row">
                <FormGroup containerClass="col-md-6">
                  <label><Translate id="location"/></label>
                  <Text field="location" className="form-control"/>
                </FormGroup>

              </div>
              <div className="text-right">
                <button className="btn btn-info" disabled={!getValue( 'name' ) && !getValue( 'title' ) && !getValue( 'phone' ) && !getValue( 'email' ) && !getValue( 'location' )} ><Translate id="search"/></button>
              </div>
            </form>
          }
        </Form>
        }
        {this.state.submitted &&
        <a onClick={this.toogleSubmmitted} className='color-purple pointer'><i className="icon-search text-small mr-2"/>Back to search form</a>
        }
        {this.state.submitted &&
        <ReactTable className="app-table-white"
                      data={this.state.data}
                      pageSize={10}
                      pageSizeOptions={[10]}
                      showPagination
                      resizable={false}
                      filterable
                      columns={[
                        { Header: <Translate id="name"/>, accessor: 'displayName' },
                        { Header: <Translate id="title"/>, accessor: 'title' },
                        { Header: <Translate id="phone"/>, accessor: 'telephoneNumber' },
                        { Header: <Translate id="contactAddress"/>, accessor: 'contactAddress', maxWidth: 120, },
                        { Header: <Translate id="location"/>, accessor: 'location',},
                        {
                          Header: '', accessor: 'id', maxWidth: 120,
                          Cell: props =>
                            <div>
                              <button className="btn btn-outline-info btn-sm ml-2"
                                      onClick={() => onClose( {email:props.original.displayName[0], id:props.original.contactAddress}, emailField )}>
                                {!props.original.active
                                  ? <i className="fa fa-check"/> : <i className="fa fa-close"/>}
                              </button>
                            </div>
                        },
                      ]}
          />
          } 
      </Modal>
    )
  }
}


const mapStateToProps = ( state ) => ( {
  isLoading: state.settings.isLoading
} );

const mapDispatchToProps = dispatch => ( {
  toggleAlertError: ( message ) => {
    dispatch( toggleAlertError( message ) );
  },
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
} );

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)( SearchComplaintModal );




// WEBPACK FOOTER //
// ./routes/app/components/Agent/SearchContactsFilterModal/index.js